export default __webpack_public_path__ + "static/media/slider_webinar_mobile.b9cfb844.webp";